/* src/app/components/lead-details/login-details/login-details.component.css */
.login-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.login-card {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: #ffffff;
}
.login-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.login-card-username {
  font-weight: 600;
  font-size: 1.143rem;
}
.login-card-delete {
  margin-left: auto;
}
.login-card-body {
  display: grid;
  grid-template-columns: max-content 1fr max-content 1fr;
  column-gap: 12px;
  row-gap: 6px;
  margin-top: 12px;
}
.login-card-field {
  display: contents;
  font-size: 1rem;
}
.login-card-field:first-child .login-card-value {
  grid-column: 2 / -1;
}
.login-card-label {
  color: #262626;
  font-weight: 500;
}
.login-card-value {
  color: #8c8c8c;
}
.login-cards-empty {
  color: #8c8c8c;
  font-style: italic;
}
/*# sourceMappingURL=login-details.component-EDQBC4DW.css.map */
